<template>
  <div class="medicine-card-wrap">
    <div
      class="card card-medicine"
      :class="{ 'card-medicine--empty': Number(data.stock) <= 0 }"
      role="button"
      tabindex="0"
      :aria-disabled="Number(data.stock) <= 0 ? 'true' : 'false'"
      :aria-label="`${data.name}, stok ${data.stock || 0}`"
      @click="cardOnClick(data, effectivePromoAmount(data))"
      @keyup.enter="cardOnClick(data, effectivePromoAmount(data))"
    >
      <div class="image-container medicine-card__media">
        <img class="medicine-card__image" :src="data.photo || '/media/medicine/medicine-default.svg'" :alt="data.name" @error="useDefaultImage">
      </div>
      <div class="medicine-card__body">
        <div class="card-text text-truncate medicine-card__name">{{ data.name }}</div>
        <div class="medicine-card__meta">
          <div class="medicine-card__price">
            <div>Rp {{ parseInt(parseInt(data.sales_price) - effectivePromoAmount(data)).toLocaleString('id-ID') }}</div>
            <span v-if="data.promo">
              <b-badge class="medicine-card__promo">
                {{ getPromoInfo(data) }}
              </b-badge>
              <small><s>{{ parseInt(data.sales_price).toLocaleString('id-ID') }}</s></small>
            </span>
            <span v-else-if="data.candidate_promo" class="medicine-card__conditional">
              <b-badge>Promo bersyarat</b-badge>
              <small :title="data.promotion_reason">{{ data.candidate_promo.name }}</small>
            </span>
          </div>
          <div class="medicine-card__stock" :class="{ 'medicine-card__stock--empty': Number(data.stock) <= 0 }">
            {{ Number(data.stock) > 0 ? `${data.stock} ${data.uom_name || 'pcs'}` : 'Stok habis' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getPromoAmount } from "@/core/modules/Helper.js"

export default {

  props: {
    data: Object
  },

  methods: {

    useDefaultImage(event) {
      if (event.target.src.indexOf("medicine-default.svg") === -1) event.target.src = "/media/medicine/medicine-default.svg"
    },

    cardOnClick(data, promoAmount) {
      this.$emit('cardOnClick', data, promoAmount)
    },

    getPromoInfo(item) {
      let result = ``
      if (item.promo) {
        if (item.promo.is_percent == 1)
          result = `${item.promo.name} · ${parseInt(item.promo.amount)}% (hemat Rp ${parseInt(this.effectivePromoAmount(item)).toLocaleString('id-ID')})`
        else
          result = `${item.promo.name} · hemat Rp ${parseInt(this.effectivePromoAmount(item)).toLocaleString('id-ID')}`
      }
      return result
    },

    effectivePromoAmount(item) {
      if (item.promotion_status) return Number(item.promo_amount) || 0
      return getPromoAmount(item.promo, item.sales_price)
    },

    getPromoAmount(promo, amount) {
      return getPromoAmount(promo, amount)
    }

  }

}
</script>

<style scoped>
.card-medicine {
  height: 100%;
  overflow: hidden;
  border: 1px solid #e3eaf2 !important;
  border-radius: 16px !important;
  background: #fff;
  box-shadow: 0 8px 22px rgba(var(--skin-deep-rgb), 0.05) !important;
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
}

.card-medicine:hover {
  transform: translateY(-2px);
  border-color: rgba(var(--skin-secondary-rgb), 0.45) !important;
  box-shadow: 0 12px 26px rgba(var(--skin-deep-rgb), 0.1) !important;
  cursor: pointer;
}

.card-medicine:focus { outline: 3px solid rgba(var(--skin-secondary-rgb), 0.16); outline-offset: 2px; }
.card-medicine--empty { opacity: .62; box-shadow: none !important; }
.card-medicine--empty:hover { transform: none; border-color: #e3eaf2 !important; }
.medicine-card__media { display: grid; place-items: center; height: 112px; margin: 8px; overflow: hidden; border-radius: 12px; background: linear-gradient(145deg, #f7fafc, #eef7f6); }
.medicine-card__image { display: block; width: 86px; height: 86px; position: static !important; object-fit: contain; }
.medicine-card__body { min-height: 80px; padding: 2px 12px 12px; }
.medicine-card__name { margin-bottom: 7px; color: #1a2433; font-size: 12px; font-weight: 750; }
.medicine-card__meta { display: flex; align-items: flex-end; justify-content: space-between; gap: 8px; }
.medicine-card__price { min-width: 0; color: var(--skin-deep); font-size: 11px; }
.medicine-card__price > div { font-size: 12px; font-weight: 800; }
.medicine-card__price span { display: flex; align-items: center; gap: 5px; margin-top: 3px; }
.medicine-card__promo { padding: 3px 6px; border-radius: 999px; color: #dc3d3d; background: #fff0f0; font-size: 8px; }
.medicine-card__conditional { min-width: 0; color: #8a6116; }
.medicine-card__conditional .badge { flex: 0 0 auto; color: #7a5412; background: #fff3cd; font-size: 8px; }
.medicine-card__conditional small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.medicine-card__stock { flex: 0 0 auto; padding: 4px 7px; border-radius: 999px; color: var(--skin-primary); background: var(--skin-soft); font-size: 9px; font-weight: 750; }
.medicine-card__stock--empty { color: #b42318; background: #fff0f0; }
</style>
